<div
  class="p-1 rounded-xl cursor-pointer w-full bg-base-300 dark:bg-dark-base-300 border border-primary-border dark:border-dark-primary-border"
  (click)="toggleTheme()"
  [ngClass]="{ dark: uiStore.theme() === 'dark' }"
  [dxTooltip]="
    uiStore.theme() === 'light' ? 'Chuyển sang chế độ tối' : 'Chuyển sang chế độ sáng'
  "
  [dxTooltipHideDelay]="1000"
  [dxTooltipShowDelay]="2000"
  [dxTooltipPosition]="'left'"
>
  <div
    class="flex flex-row overflow-hidden text-neutral-content dark:text-dark-neutral-content bg-transparent"
  >
    <div
      class="flex-1 flex w-full items-center justify-between justify-center space-x-2 rounded-lg p-1"
      [ngClass]="{
        'bg-base-400 dark:bg-dark-base-400 inset-shadow-xs inset-shadow-decoration-100 shadow-md': uiStore.theme() === 'light'
      }"
    >
      <app-svg-icon
        type="icSun"
        class="w-6 h-6 text-2xl mr-2"
        [ngClass]="[
          uiStore.theme() === 'light'
            ? '!text-base-content dark:!text-dark-base-content'
            : '!text-neutral-content dark:!text-dark-neutral-content'
        ]"
      ></app-svg-icon>
      <div
        class="text-[15px]"
        [ngClass]="[
          uiStore.theme() === 'light' ? 'font-semibold' : 'font-medium',
          uiStore.theme() === 'light'
            ? 'text-base-content dark:text-dark-base-content'
            : 'text-neutral-content dark:text-dark-neutral-content'
        ]"
      >
        Sáng
      </div>
    </div>
    <div
      class="flex-1 flex w-full items-center justify-between justify-center space-x-2 rounded-lg p-1"
      [ngClass]="{
        'bg-base-400 dark:bg-dark-base-400 inset-shadow-xs dark:inset-shadow-dark-decoration-100 shadow-md': uiStore.theme() === 'dark'
      }"
    >
      <app-svg-icon
        type="icMoon"
        class="w-6 h-6 text-2xl mr-2"
        [ngClass]="[
          uiStore.theme() === 'dark'
            ? '!text-base-content dark:!text-dark-base-content '
            : '!text-neutral-content dark:!text-dark-neutral-content'
        ]"
      ></app-svg-icon>
      <div
        class="text-[15px]"
        [ngClass]="[
          uiStore.theme() === 'dark' ? 'font-semibold' : 'font-medium',
          uiStore.theme() === 'dark'
            ? 'text-base-content dark:text-dark-base-content'
            : 'text-neutral-content dark:text-dark-neutral-content'
        ]"
      >
        Tối
      </div>
    </div>
  </div>
</div>
